// Keep offscreen photographs out of the initial download queue. Markup remains
// in a template (and a noscript fallback), with dimensions reserved by the card.
class NearbyImage extends HTMLElement {
  connectedCallback() {
    const target = this.parentElement;
    if (!target || !('IntersectionObserver' in window) || window.Shopify?.designMode) {
      this.reveal();
      return;
    }
    this.observer = new IntersectionObserver(entries => {
      if (entries.some(entry => entry.isIntersecting)) this.reveal();
    }, { rootMargin: '200px' });
    this.observer.observe(target);
    target.addEventListener('pointerenter', this.reveal, { once: true });
    target.addEventListener('focusin', this.reveal, { once: true });
    this.target = target;
  }
  disconnectedCallback() {
    this.observer?.disconnect();
    this.target?.removeEventListener('pointerenter', this.reveal);
    this.target?.removeEventListener('focusin', this.reveal);
  }
  reveal = () => {
    const template = this.querySelector('template');
    if (!template) return;
    this.observer?.disconnect();
    this.replaceWith(template.content.cloneNode(true));
  };
}
if (!customElements.get('nearby-image')) customElements.define('nearby-image', NearbyImage);
